import * as api from "../api";
import * as actionsType from "./actionsType";
import { errorHandler } from "./general";

// ──────────────────────────────────────────────
// Admin Analytics Actions
// ──────────────────────────────────────────────

export const setAnalyticsFilters = (filters) => ({
  type: actionsType.SET_ANALYTICS_PERIOD,
  payload: filters,
});

export const getAnalyticsSummary = (params, history) => async (dispatch) => {
  try {
    dispatch({ type: actionsType.SET_ANALYTICS_LOADING, payload: true });
    const { data } = await api.getAnalyticsSummary(params);
    dispatch({ type: actionsType.GET_ANALYTICS_SUMMARY, payload: data.data || data });
    dispatch({ type: actionsType.SET_ANALYTICS_LOADING, payload: false });
  } catch (error) {
    dispatch({ type: actionsType.SET_ANALYTICS_LOADING, payload: false });
    dispatch(errorHandler(error, history));
  }
};

export const getAnalyticsTimeseries = (params, history) => async (dispatch) => {
  try {
    const { data } = await api.getAnalyticsTimeseries(params);
    dispatch({ type: actionsType.GET_ANALYTICS_TIMESERIES, payload: data.data || data });
  } catch (error) {
    dispatch(errorHandler(error, history));
  }
};

export const getAnalyticsPlatforms = (params, history) => async (dispatch) => {
  try {
    const { data } = await api.getAnalyticsPlatforms(params);
    dispatch({ type: actionsType.GET_ANALYTICS_PLATFORMS, payload: data.data || data });
  } catch (error) {
    dispatch(errorHandler(error, history));
  }
};

export const getAnalyticsEvents = (params, history) => async (dispatch) => {
  try {
    const { data } = await api.getAnalyticsEvents(params);
    dispatch({ type: actionsType.GET_ANALYTICS_EVENTS, payload: data.data || data });
  } catch (error) {
    dispatch(errorHandler(error, history));
  }
};

export const getAnalyticsQuality = (params, history) => async (dispatch) => {
  try {
    const { data } = await api.getAnalyticsQuality(params);
    dispatch({ type: actionsType.GET_ANALYTICS_QUALITY, payload: data.data || data });
  } catch (error) {
    dispatch(errorHandler(error, history));
  }
};

export const getAnalyticsSources = (history) => async (dispatch) => {
  try {
    const { data } = await api.getAnalyticsSources();
    dispatch({ type: actionsType.GET_ANALYTICS_SOURCES, payload: data.data || data });
  } catch (error) {
    dispatch(errorHandler(error, history));
  }
};

export const syncAnalyticsData = (params, history) => async (dispatch) => {
  try {
    dispatch({ type: actionsType.SET_ANALYTICS_LOADING, payload: true });
    const { data } = await api.syncAnalyticsData(params);
    // HTTP 202 — sync is queued, don't re-fetch immediately
    dispatch({ type: actionsType.SET_ANALYTICS_LOADING, payload: false });
    return data; // caller can show "queued" message
  } catch (error) {
    dispatch({ type: actionsType.SET_ANALYTICS_LOADING, payload: false });
    dispatch(errorHandler(error, history));
    throw error;
  }
};

// ──────────────────────────────────────────────
// Company Admin Map Actions
// ──────────────────────────────────────────────

export const setMapPeriod = (period) => ({
  type: actionsType.SET_MAP_PERIOD,
  payload: period,
});

export const getMapData = (params, history) => async (dispatch) => {
  try {
    dispatch({ type: actionsType.SET_MAP_LOADING, payload: true });
    const { data } = await api.getMapData(params);
    dispatch({ type: actionsType.GET_MAP_DATA, payload: data.data || data });
    dispatch({ type: actionsType.SET_MAP_LOADING, payload: false });
  } catch (error) {
    dispatch({ type: actionsType.SET_MAP_LOADING, payload: false });
    dispatch(errorHandler(error, history));
  }
};

export const getMapBranchDetail = (branchId, paramsOrHistory, maybeHistory) => async (dispatch) => {
  try {
    const params = typeof paramsOrHistory === "object" && !paramsOrHistory.push ? paramsOrHistory : {};
    const history = typeof paramsOrHistory === "object" && paramsOrHistory.push ? paramsOrHistory : maybeHistory;
    const { data } = await api.getMapBranchDetail(branchId, params);
    dispatch({ type: actionsType.GET_MAP_BRANCH_DETAIL, payload: data.data || data });
  } catch (error) {
    const history = typeof paramsOrHistory === "object" && paramsOrHistory.push ? paramsOrHistory : maybeHistory;
    dispatch(errorHandler(error, history));
  }
};

export const getMapCollectionNetwork = (params, history) => async (dispatch) => {
  try {
    const { data } = await api.getMapCollectionNetwork(params);
    dispatch({ type: actionsType.GET_MAP_COLLECTION_NETWORK, payload: data.data || data });
  } catch (error) {
    dispatch(errorHandler(error, history));
  }
};

export const getMapRecyclingPerformance = (params, history) => async (dispatch) => {
  try {
    const { data } = await api.getMapRecyclingPerformance(params);
    dispatch({ type: actionsType.GET_MAP_RECYCLING_PERFORMANCE, payload: data.data || data });
  } catch (error) {
    dispatch(errorHandler(error, history));
  }
};
